import { roles } from "../config/config";

export const eventsPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
  roles.contabile,
  roles.grafico,
];

export const getEventsPermissions = (userIsAgente) => [
  ...eventsPermissions,
  userIsAgente,
];
